var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDbIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 10C15.866 10 19 8.657 19 7C19 5.343 15.866 4 12 4C8.134 4 5 5.343 5 7C5 8.657 8.134 10 12 10Z",
  fill: "#636A7D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 9V12C5 13.657 8.134 15 12 15C15.866 15 19 13.657 19 12V9C19 10.657 15.866 12 12 12C8.134 12 5 10.657 5 9Z",
  fill: "#636A7D"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 14V17C5 18.657 8.134 20 12 20C15.866 20 19 18.657 19 17V14C19 15.657 15.866 17 12 17C8.134 17 5 15.657 5 14Z",
  fill: "#636A7D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDbIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/db-icon.78ebc6f9ceb3fa23709818a3711033b0.svg";